(function () {
  if (window.__nestLreCartReconciler20260703) return;
  window.__nestLreCartReconciler20260703 = true;

  var reconcileTimer = null;
  var reconcileRunning = false;
  var rerunRequested = false;
  var quietUntil = 0;

  var lreBySize = {
    'Twin': 39478354903121,
    'Twin XL': 39478354935889,
    'Full': 39478354968657,
    'Queen': 39478355001425,
    'King': 39478355034193,
    'Cal King': 39478355066961,
    'Split CK 1-side': 39478355099729
  };

  var sizeByMattressVariant = {
    32778464788561: 'Twin', 32778464821329: 'Twin', 32778464854097: 'Twin', 32778464886865: 'Twin XL', 32778464919633: 'Twin XL', 32778464952401: 'Twin XL', 32778465574993: 'Split CK 1-side', 32778465607761: 'Split CK 1-side', 32778465640529: 'Split CK 1-side', 32778464985169: 'Full', 32778465017937: 'Full', 32778465050705: 'Full', 32778464690257: 'Queen', 32778464723025: 'Queen', 32778464755793: 'Queen', 32778465181777: 'King', 32778465214545: 'King', 32778465247313: 'King', 32778465083473: 'King', 32778465116241: 'King', 32778465149009: 'King', 32778465476689: 'Cal King', 32778465509457: 'Cal King', 32778465542225: 'Cal King', 32778465378385: 'Cal King', 32778465411153: 'Cal King', 32778465443921: 'Cal King',
    32778468556881: 'Twin', 32778468589649: 'Twin', 32778468622417: 'Twin', 32778468655185: 'Twin XL', 32778468687953: 'Twin XL', 32778468720721: 'Twin XL', 32778469343313: 'Split CK 1-side', 32778469376081: 'Split CK 1-side', 32778469408849: 'Split CK 1-side', 32778468753489: 'Full', 32778468786257: 'Full', 32778468819025: 'Full', 32778468458577: 'Queen', 32778468491345: 'Queen', 32778468524113: 'Queen', 32778468950097: 'King', 32778468982865: 'King', 32778469015633: 'King', 32778468851793: 'King', 32778468884561: 'King', 32778468917329: 'King', 32778469245009: 'Cal King', 32778469277777: 'Cal King', 32778469310545: 'Cal King', 32778469146705: 'Cal King', 32778469179473: 'Cal King', 32778469212241: 'Cal King',
    40440621989969: 'Twin', 40440622088273: 'Twin XL', 40440622186577: 'Split CK 1-side', 40440622284881: 'Full', 40440622415953: 'Queen', 40440622514257: 'King', 40440622710865: 'Cal King'
  };

  var lreSizeByVariant = Object.keys(lreBySize).reduce(function (map, size) {
    map[lreBySize[size]] = size;
    return map;
  }, {});

  function mark(name, detail) {
    if (window.NestLreCartTiming && typeof window.NestLreCartTiming.mark === 'function') {
      window.NestLreCartTiming.mark(name, detail);
    }
  }

  function isCartMutationUrl(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)\.js|\/cart\/add|\/cart\/change|\/cart\/update/.test(url);
  }

  function countRequiredLre(cart) {
    return (cart.items || []).reduce(function (required, item) {
      var size = sizeByMattressVariant[Number(item.variant_id)];
      if (!size) return required;
      required[size] = (required[size] || 0) + Number(item.quantity || 0);
      return required;
    }, {});
  }

  function countActualLre(cart) {
    return (cart.items || []).reduce(function (actual, item) {
      var size = lreSizeByVariant[Number(item.variant_id)];
      if (!size) return actual;
      actual[size] = (actual[size] || 0) + Number(item.quantity || 0);
      return actual;
    }, {});
  }

  function cartHasRelevantItems(cart) {
    return (cart.items || []).some(function (item) {
      return !!(sizeByMattressVariant[Number(item.variant_id)] || lreSizeByVariant[Number(item.variant_id)]);
    });
  }

  function buildUpdates(cart) {
    var required = countRequiredLre(cart);
    var actual = countActualLre(cart);
    var updates = {};
    var changed = false;

    Object.keys(lreBySize).forEach(function (size) {
      var variantId = lreBySize[size];
      var needed = Number(required[size] || 0);
      var current = Number(actual[size] || 0);
      if (needed !== current) {
        updates[String(variantId)] = needed;
        changed = true;
      }
    });

    return changed ? { updates: updates, required: required, actual: actual } : null;
  }

  function refreshCart() {
    window.setTimeout(function () {
      if (typeof window.UpdateCart === 'function') {
        mark('LRE reconcile refresh cart');
        window.UpdateCart();
      }
    }, 80);
  }

  function runReconcile(reason) {
    if (reconcileRunning) {
      rerunRequested = true;
      return;
    }
    if (!window.fetch) return;

    reconcileRunning = true;
    mark('LRE reconcile check', reason || 'scheduled');

    window.fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cartHasRelevantItems(cart)) {
          mark('LRE reconcile skipped', 'no mattress or LRE items');
          return null;
        }

        var diff = buildUpdates(cart);
        if (!diff) {
          mark('LRE reconcile already balanced', {
            required: countRequiredLre(cart),
            actual: countActualLre(cart)
          });
          return null;
        }

        mark('LRE reconcile update', diff);
        return window.fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: diff.updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('LRE reconcile update failed: ' + response.status);
          return response.json();
        }).then(function (updatedCart) {
          mark('LRE reconcile complete', { item_count: updatedCart.item_count, total_price: updatedCart.total_price });
          refreshCart();
          return updatedCart;
        });
      })
      .catch(function (error) {
        mark('LRE reconcile error', error && error.message ? error.message : String(error));
      })
      .then(function () {
        reconcileRunning = false;
        if (rerunRequested) {
          rerunRequested = false;
          scheduleReconcile('rerun requested', 120);
        }
      });
  }

  function scheduleReconcile(reason, delay) {
    if (reconcileTimer) window.clearTimeout(reconcileTimer);
    var wait = typeof delay === 'number' ? delay : 220;
    quietUntil = Date.now() + wait;
    reconcileTimer = window.setTimeout(function () {
      reconcileTimer = null;
      if (Date.now() < quietUntil) {
        scheduleReconcile(reason, Math.max(40, quietUntil - Date.now()));
        return;
      }
      runReconcile(reason);
    }, wait);
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestLreReconcilerPatched20260703) return;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url;
      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartMutationUrl(url)) scheduleReconcile('after fetch ' + url, 220);
        return response;
      });
    };
    window.fetch.__nestLreReconcilerPatched20260703 = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__nestLreReconcilerPatched20260703) return;
    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      this.__nestLreReconcileUrl20260703 = String(url || '');
      return originalOpen.apply(this, arguments);
    };

    proto.send = function () {
      var xhr = this;
      var url = xhr.__nestLreReconcileUrl20260703;
      if (isCartMutationUrl(url)) {
        xhr.addEventListener('loadend', function () {
          scheduleReconcile('after xhr ' + url, 220);
        });
      }
      return originalSend.apply(this, arguments);
    };

    proto.__nestLreReconcilerPatched20260703 = true;
  }

  function init() {
    patchFetch();
    patchXhr();
    scheduleReconcile('initial', 700);
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('button, a, input') : null;
    if (!target) return;
    var signal = [target.className, target.name, target.getAttribute('href'), target.getAttribute('aria-label'), target.textContent].join(' ').toLowerCase();
    if (/add|remove|delete|quantity|cart|checkout/.test(signal)) scheduleReconcile('after cart control click', 260);
  }, true);

  document.addEventListener('change', function () {
    scheduleReconcile('after cart control change', 260);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();